import { IIconProps, ITextFieldStyles, mergeStyleSets } from '@fluentui/react';

export const getClassNames = (hasError: boolean) =>
  mergeStyleSets({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      maxWidth: '100%',
      position: 'relative',
    },
    textField: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      position: 'relative',
      marginBottom: hasError ? '1.5em' : 0,
    },
    icon: {
      fontSize: '24px',
    },
  });

export const classNames = getClassNames(false);

export const pickerIconProps: IIconProps = {
  iconName: 'xappex-target',
  styles: { root: classNames.icon },
};

export const clearIconProps: IIconProps = {
  iconName: 'xappex-delete',
  styles: { root: classNames.icon },
};

export const textFieldStyles: Partial<ITextFieldStyles> = {
  errorMessage: {
    position: 'absolute',
  },
};

export const inputIconStyles: React.CSSProperties = {
  pointerEvents: 'auto',
  cursor: 'pointer',
};
